// Theme.js
'use strict';

//import "@babel/polyfill/dist/polyfill.min";
//import "@babel/polyfill/noConflict";

// Not use import because replace "$" and fancybox is not OK.
//var $ = require('jquery/dist/jquery.min');

import bsBreakpoints from "bs-breakpoints/dist/bs-breakpoints.min";
//import Mustache from "mustache/mustache.min";
//import Cookies from "js-cookie";
// bootstrap.bundle.min.js has popper.min.js, bootstrap.min.js not.
import "bootstrap/dist/js/bootstrap.bundle.min";

//require('@fancyapps/fancybox/dist/jquery.fancybox.min');
import "@fancyapps/fancybox/dist/jquery.fancybox.min";

/**
 * Theme Class
 */
export default class BatibarsunDefaultTheme {
	/**
	 * Init theme.
	 */
	static init() {
		this.initResponsiveBgImages();
		this.initGdpr();
		this.initHovers();
		this.initNavigation();
		this.initTextareaLimit();
		this.initGalleryPhotos();
		this.initAnimations();
		this.initVideo();
		this.initSocial();
	}

	static setResponsiveBgImages() {
		$(".responsive-bg-image").each(function (index, element) {
			var currentBreakpoint = bsBreakpoints.getCurrentBreakpoint();
			var attributTarget = 'data-bg-image-xl';

			switch (currentBreakpoint) {
				case 'xSmall': // min:0,max:575
					attributTarget = 'data-bg-image-xs';
					break;
				case 'small': // min:576,max:767
					attributTarget = 'data-bg-image-sm';
					break;
				case 'medium': // min:768,max:991
					attributTarget = 'data-bg-image-md';
					break;
				case 'large': // min:992,max:1199
					attributTarget = 'data-bg-image-lg';
					break;
				case 'xLarge': // min:1200,max:1/0
					attributTarget = 'data-bg-image-xl';
					break;
			}

			var bgImageUrl = $(this).attr(attributTarget);
			if (typeof bgImageUrl !== 'undefined') {
				$(this).attr('style', 'background-image: url(\'' + bgImageUrl + '\')');
			}
		});
	}

	static initResponsiveBgImages() {
		this.setResponsiveBgImages();

		$(window).on('init.bs.breakpoint', function (e) {
			// on init
			BatibarsunDefaultTheme.setResponsiveBgImages();
		});

		$(window).on('new.bs.breakpoint', function (e) {
			// on change
			BatibarsunDefaultTheme.setResponsiveBgImages();
		});
	}

	static initGdpr() {

	}

	static initNavigation() {
		var currentBreakpoint = bsBreakpoints.getCurrentBreakpoint();

		$('body')
			.on('mouseenter mouseleave', '.dropdown', function(e) {
				//toggleDropdown()
			})
			.on('click', '.dropdown > a', function(e) {
				window.location = $(this).attr('href');
				//toggleDropdown()
			});
	}

	static initHovers() {
		$(".block-gallery-item > figure > a").hover(
			function(){
				$(".caption-hover").hide();
				$(this).find(".caption-hover").fadeIn(500);
			},

			function () {
				$(this).find(".caption-hover").hide();
			}
		);
	}

	static initGalleryPhotos() {
		$('[data-fancybox="gallery"]').fancybox({
			caption : function( instance, item ) {
				var caption = $(this).data('caption') || '';
				var description = $(this).data('description') || '';
				var credits = $(this).data('credits') || '';

				if (caption.length) {
					caption = '<span class="title">' + caption + '</span><br />';
				}

				if (description.length) {
					caption += '<span class="description"> ' + description + '</span><br />';
				}

				if (credits.length) {
					caption += '<span class="credits"> ' + credits + '</span>';
				}

				return caption;
			},
			lang: "fr",
			i18n: {
				fr: {
					CLOSE: "Fermer",
					NEXT: "Suivant",
					PREV: "Précédent",
					ERROR: "Le contenu demandé ne peut pas être chargé. <br/> Veuillez réessayer plus tard.",
					PLAY_START: "Démarrer le diaporama",
					PLAY_STOP: "Pause du diaporama",
					FULL_SCREEN: "Plein écran",
					THUMBS: "Vignettes",
					DOWNLOAD: "Télécharger",
					SHARE: "Partager",
					ZOOM: "Zoom"
				}
			},
			thumbs : {
				autoStart : false
			}
		});
	}

	static initAnimations() {

	}

	static initVideo() {
		$('a.video,p.video a').fancybox({
			lang: "fr",
			i18n: {
				fr: {
					CLOSE: "Fermer",
					NEXT: "Suivant",
					PREV: "Précédent",
					ERROR: "Le contenu demandé ne peut pas être chargé. <br/> Veuillez réessayer plus tard.",
					PLAY_START: "Démarrer le diaporama",
					PLAY_STOP: "Pause du diaporama",
					FULL_SCREEN: "Plein écran",
					THUMBS: "Vignettes",
					DOWNLOAD: "Télécharger",
					SHARE: "Partager",
					ZOOM: "Zoom"
				}
			},
		});
	}

	static initSocial() {
		$('.fb-share').click(function(e) {
			e.preventDefault();
			window.open($(this).attr('href'), 'fbShareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');

			return false;
		});
	}

	/**
	 * Init limit chars on textarea fields.
	 */
	static initTextareaLimit() {
		// eslint-disable-next-line
		$('.textarea1000').keyup(function () {
			const maxChars = 1000;
			// eslint-disable-next-line
			const text = $(this).val();

			if (text.length > maxChars) {
				// eslint-disable-next-line
				$(this).val(text.substr(0, maxChars));
			}

			// eslint-disable-next-line
			$(this).closest('.form-group').find('.msglimitchars > span').html((maxChars - $(this).val().length));
		});

		// Use to check on first load page without key pressed
		$('.textarea1000').keyup();
	}
}

$(document).ready(() => {
	bsBreakpoints.init();
	BatibarsunDefaultTheme.init();

	let btnBackToTop = $('#back-to-top');

	$(window).scroll(function () {
		if ($(window).scrollTop() > 100) {
			btnBackToTop.removeClass('hidden');
		} else {
			btnBackToTop.addClass('hidden');
		}
	});

	$('#imprimer-page').on('click', function (e) {
		e.preventDefault();
		window.print();
	});

	btnBackToTop.on('click', function (e) {
		e.preventDefault();
		$('html, body').animate({scrollTop: 0}, '300');
	});
});
